export function deCodeOccupancies(
  slug: string,
): { adults: number; children: number[] }[] {

  const decodedRooms = slug.split("__").map((roomData) => {
    const decodedRoomData = decodeURIComponent(roomData);
    const adultsMatch = decodedRoomData.match(/a(\d+)/);
    const childrenMatch = decodedRoomData.match(/c(\d*)/);
    if (adultsMatch) {
      const adults = parseInt(adultsMatch[1], 10);

      const decodedChildrenAges = decodedRoomData
        .split("c")
        [decodedRoomData.split("c").length - 1].split("_");
      const children =
        decodedChildrenAges[0] === "-1" || decodedChildrenAges.length === 0
          ? []
          : decodedChildrenAges.map((item) => Number(item));
      return { adults, children };
    } else {
      // throw new Error('Invalid encoded room data');
      return { adults: 0, children: [] } as {
        adults: number;
        children: number[];
      };
    }
  });
  return decodedRooms;
}
